import React, { useEffect, useState, memo } from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import FlexWrapper from '../../../components/FlexWrapper/FlexWrapper';
import { Plus, Trash } from '../../../components/Svg/Svg';
import Spacer from '../../../components/Spacer/Spacer';
import { generateId } from '../../../utils/helpFunctions';

export default memo(function AssistanceAndInsuranceEditors({
    flag,
    data,
    onChange,
    onAddInfoBox,
    onRemoveInfoBox,
    onChangeInfoBox,
}) {
    const [currentTab, setCurrentTab] = useState('personal_assistance');

    useEffect(() => {
        setCurrentTab('personal_assistance');
    }, [flag]);

    const onEditorChange = (editor, id) => {
        const data = editor.getData();

        onChange(data, flag, id);
    };

    const onInfoBoxChange = (editor, id) => {
        const data = editor.getData();

        onChangeInfoBox(data, flag, id);
    };

    const setTab = (e) => {
        setCurrentTab(e.target.dataset.tabName);
    };

    const infoBoxes = data[flag].info_boxes
        .filter((el) => el.block_type === `${currentTab}_block`)
        .map((el) => {
            if (!el?.id) {
                el.id = generateId();
            }
            return el;
        });

    return (
        <div>
            <div className="navigation-tabs__wrapper">
                <ul className="navigation-tabs__list">
                    <li className="navigation-tabs__list-item">
                        <span
                            onClick={setTab}
                            data-tab-name="personal_assistance"
                            className={
                                currentTab === 'personal_assistance'
                                    ? 'navigation-tabs__link navigation-tabs__link--active'
                                    : 'navigation-tabs__link'
                            }
                        >
                            Personal assistance
                        </span>
                    </li>
                    <li className="navigation-tabs__list-item">
                        <span
                            onClick={setTab}
                            data-tab-name="company_assistance"
                            className={
                                currentTab === 'company_assistance'
                                    ? 'navigation-tabs__link navigation-tabs__link--active'
                                    : 'navigation-tabs__link'
                            }
                        >
                            Company assistance
                        </span>
                    </li>
                    <li className="navigation-tabs__list-item">
                        <span
                            onClick={setTab}
                            data-tab-name="personal_insurance"
                            className={
                                currentTab === 'personal_insurance'
                                    ? 'navigation-tabs__link navigation-tabs__link--active'
                                    : 'navigation-tabs__link'
                            }
                        >
                            Personal insurance
                        </span>
                    </li>
                    <li className="navigation-tabs__list-item">
                        <span
                            onClick={setTab}
                            data-tab-name="company_insurance"
                            className={
                                currentTab === 'company_insurance'
                                    ? 'navigation-tabs__link navigation-tabs__link--active'
                                    : 'navigation-tabs__link'
                            }
                        >
                            Company insurance
                        </span>
                    </li>
                </ul>
            </div>
            <div>
                <CKEditor
                    editor={Editor}
                    id={`${currentTab}_block_${flag}`}
                    config={{
                        toolbar: {
                            items: [
                                'undo',
                                'redo',
                                'heading',
                                'bold',
                                'italic',
                                'link',
                                'bulletedList',
                                'numberedList',
                                'insertTable',
                                'outdent',
                                'indent',
                                'blockQuote',
                                'htmlEmbed',
                            ],
                        },
                        link: {
                            addTargetToExternalLinks: true,
                            decorators: [
                                {
                                    mode: 'manual',
                                    label: 'Downloadable',
                                    attributes: {
                                        download: 'download',
                                    },
                                },
                            ],
                        },
                    }}
                    data={data[flag]?.[`${currentTab}_block`]}
                    onChange={(_, editor) =>
                        onEditorChange(editor, `${currentTab}_block_${flag}`)
                    }
                />
            </div>
            <Spacer size={12} />
            <div>
                <div>
                    {infoBoxes.map((el) => (
                        <div key={el.id}>
                            <FlexWrapper justify="space-between" align="center">
                                <p
                                    className="input-label"
                                    style={{ margin: 0 }}
                                >
                                    Info box
                                </p>
                                <button
                                    className="button__link"
                                    type="button"
                                    onClick={() => onRemoveInfoBox(flag, el.id)}
                                >
                                    <FlexWrapper
                                        align="center"
                                        justify="center"
                                    >
                                        <Trash /> &nbsp;&nbsp;Remove
                                    </FlexWrapper>
                                </button>
                            </FlexWrapper>
                            <Spacer size={5} />
                            <CKEditor
                                editor={Editor}
                                id={el.id}
                                config={{
                                    toolbar: {
                                        items: [
                                            'undo',
                                            'redo',
                                            'heading',
                                            'bold',
                                            'italic',
                                            'link',
                                            'bulletedList',
                                            'numberedList',
                                            'insertTable',
                                            'outdent',
                                            'indent',
                                            'blockQuote',
                                            'htmlEmbed',
                                            'fontColor',
                                        ],
                                    },
                                    link: {
                                        addTargetToExternalLinks: true,
                                        decorators: [
                                            {
                                                mode: 'manual',
                                                label: 'Downloadable',
                                                attributes: {
                                                    download: 'download',
                                                },
                                            },
                                        ],
                                    },
                                    fontColor: {
                                        colors: [
                                            {
                                                color: '#1C1C1C',
                                                label: 'Gray-9',
                                            },
                                            {
                                                color: '#3C3C3C',
                                                label: 'Gray-8',
                                            },
                                            {
                                                color: '#5B5B5B',
                                                label: 'Gray-7',
                                            },
                                            {
                                                color: '#7F7F7F',
                                                label: 'Gray-6',
                                            },
                                            {
                                                color: '#AFAFAF',
                                                label: 'Gray-5',
                                            },
                                            {
                                                color: '#43404F',
                                                label: 'Purple-9',
                                            },
                                            {
                                                color: '#7B7895',
                                                label: 'Purple-8',
                                            },
                                            {
                                                color: '#A29FB7',
                                                label: 'Purple-7',
                                            },
                                            {
                                                color: '#CDCCDA',
                                                label: 'Purple-6',
                                            },
                                            {
                                                color: '#D9D8E6',
                                                label: 'Purple-5',
                                            },
                                            {
                                                color: '#E6E6E6',
                                                label: 'Gray-3',
                                            },
                                            {
                                                color: '#F0F0F1',
                                                label: 'Gray-2',
                                            },
                                            {
                                                color: '#F8F8F8',
                                                label: 'Gray-1',
                                            },
                                            {
                                                color: '#E4E3EC',
                                                label: 'Purple-4',
                                            },
                                            {
                                                color: '#ECEAF3',
                                                label: 'Purple-3',
                                            },
                                            {
                                                color: '#F5F4F9',
                                                label: 'Purple-2',
                                            },
                                            {
                                                color: '#F9F9FC',
                                                label: 'Purple-1',
                                                hasBorder: true,
                                            },
                                            {
                                                color: '#FFFFFF',
                                                label: 'White',
                                                hasBorder: true,
                                            },
                                        ],
                                    },
                                }}
                                data={el.block_content}
                                onChange={(_, editor) =>
                                    onInfoBoxChange(editor, el.id)
                                }
                            />
                            <Spacer size={12} />
                        </div>
                    ))}
                </div>
                <button
                    className="button__link"
                    type="button"
                    onClick={() => onAddInfoBox(currentTab, flag)}
                >
                    <FlexWrapper align="center" justify="center">
                        <Plus />
                        &nbsp;&nbsp;Add info box
                    </FlexWrapper>
                </button>
            </div>
        </div>
    );
});
